import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const leaveConversation = (conversationId: string) =>
    RESTClient.postAuthenticatedObservable(`v2/conversations/${conversationId}/leave`);
